import { Message } from 'element-ui'

// 换行符替换为br
const textareaWrap = content => {
  return content ? content.replace(/\n/g, '<br/>') : content
}

// 函数防抖
const Debounce = (fn, t) => {
  let delay = t || 500
  let timer
  return function () {
    let args = arguments;
    if (timer) {
      clearTimeout(timer)
    }

    let callNow = !timer

    timer = setTimeout(() => {
      timer = null
    }, delay)

    if (callNow) fn.apply(this, args)
  }
}
/**
 * 识别字符串url并给url加上a标签
 * */
const formatStringUrl = str => {
  str = str || ''
  // let regexp = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|\&|-)+)/g;
  // return str.replace(regexp, function($url){
  //   return "<a href='" + $url + "' target='_blank'>" + $url + "</a>";
  // });
  //写的url正则匹配
  // let reg = /((http|ftp|https):\/\/)?[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&amp;:/~\+#]*[\w\-\@?^=%&amp;/~\+#])?/g;
  let reg = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/g;
  //正则替换
  return str.replace(reg, function (a) {
    //如果包含http ，indexOf方法如果包含返回0,所以加上!
    if (!a.indexOf('http')) {
      return '<a href="' + a + '" target=_blank>' + a + '</a>';
    } else {
      return '<a href="http://' + a + '" target=_blank>' + a + '</a>';
    }
  });
}

// 平铺数据格式化成树形
const Tree = (data, childrenId, parentId) => {
  const cloneData = JSON.parse(JSON.stringify(data)); // 对源数据深度克隆
  const tree = cloneData.filter((father) => {
    //循环所有项
    const branchArr = cloneData.filter((child) => {
      return father[childrenId] == child[parentId]; //返回每一项的子级数组
    });
    if (branchArr.length > 0) {
      father.children = branchArr; //如果存在子级，则给父级添加一个children属性，并赋值
    }
    return father[parentId] == 0; //返回第一层
  });
  return tree;
}

// IE等浏览器无法使用window.open方法
export function windowOpen(url) {
  let newElement = document.createElement("a");
  newElement.style.display = "none";
  newElement.setAttribute('target', "_blank");
  newElement.href = url;
  document.body.appendChild(newElement);
  newElement.click();
  setTimeout(() => {
    document.body.removeChild(newElement);
  }, 1000);
}

export const tokenKey = 'SSO_TOKEN'

export const local = {
  set(key, val) {
    if (window) typeof val == 'string' ? window.localStorage.setItem(key, val) : window.localStorage.setItem(key, JSON.stringify(val))
  },
  get(key) {
    if (window) {
      let val = window.localStorage.getItem(key)
      try {
        return typeof val == 'string' ? JSON.parse(val) : val
      } catch (e) {
        return val
      }
    }
  },
  clear() {
    window.localStorage.clear()
  },
  remove(key) {
    window.localStorage.removeItem(key)
  }
}

// 下载文件错误捕获，以及下载
export const DownLoadFile = (res, filename) => {
  let data = res.data;
  let fileReader = new FileReader();
  fileReader.readAsText(data)
  fileReader.onload = (e) => {
    try {
      let jsonData = JSON.parse(e.target.result); // 说明是普通对象数据，后台转换失败
      if (jsonData.resultCode !== "0") {
        Message.error(jsonData.resultMsg || '网络异常');
        return
      } else if (jsonData.resultCode === '9978') {
        Message.error('登录失效')
        location.reload()
        return
      }
    } catch (err) { // 解析成对象失败，说明是正常的文件流
      // IE下载
      // @ts-ignore
      if (window.navigator.msSaveOrOpenBlob) {
        var blobObject = new Blob([res.data], {
          type: "application/actet-stream;charset=utf-8",
        });
        window.navigator.msSaveBlob(blobObject, filename);
      } else {
        //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
        var contentDisposition = res.headers["content-disposition"];
        if (contentDisposition) {
          var patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
          var result = patt.exec(contentDisposition);
          filename = result ? decodeURIComponent(result[1]) : filename;
        }
        var blob = new Blob([res.data], {
          type: "application/actet-stream;charset=utf-8",
        });
        var downloadElement = document.createElement("a");
        var href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.style.display = "none";
        downloadElement.href = href;
        downloadElement.download = decodeURI(filename).replace(
            /\+/g,
            " "
        );
        document.body.appendChild(downloadElement);
        downloadElement.click();
        setTimeout(() => {
          document.body.removeChild(downloadElement);
          window.URL.revokeObjectURL(href);
        }, 1000);
      }
    }
  }
}

export function HTMLEncode(text) {
  text = text || ''
  return text
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
}

/* 
  平行数组生成树形数组结构
*/
export function createTreeData(data, childrenId, parentId) {
  const cloneData = JSON.parse(JSON.stringify(data)); // 对源数据深度克隆
  const tree = cloneData.filter((father) => {
    //循环所有项
    const branchArr = cloneData.filter((child) => {
      return father[childrenId] == child[parentId]; //返回每一项的子级数组
    });
    if (branchArr.length > 0) {
      father.children = branchArr; //如果存在子级，则给父级添加一个children属性，并赋值
    }
    return father[parentId] == 0; //返回第一层
  });
  return tree;
}

export const phoneReg = /^1[2|3|4|5|6|7|8|9][0-9]\d{8}$/
export const emailReg = /^[a-zA-Z0-9_.-]+@\w+([-.][A-Za-z0-9]+)*\.\w+([-.][A-Za-z0-9]+)*$/


export {
  textareaWrap,
  Tree,
  formatStringUrl,
  Debounce,
}
